<template>
	<div>
		<!-- <link href='https://fonts.googleapis.com/css?family=GFS+Didot|Montserrat:400,700' rel='stylesheet' type='text/css' /> -->
		<!-- <link rel="stylesheet" href="https://www.brightonretail.com/header_and_footer/2017-07-21/style.css?<?=time()?>" type="text/css" media="all" /> -->

	

		
		<div id="footer">
			<ul>
				<li><a href="http://www.brightoncollectibles.com/store">HOME</a></li>
			</ul>
		</div>
						
	</div>
</template>
<style scoped>
	#footer{
		margin-top:40px;
		text-align:center;
		display:block;
		background-color:#808080;
	}
	#footer ul{
		float: none;
	    display: inline-block;
	    list-style: none;
	}
    #footer ul a{
        color:#fff;
        font: 12px/23px 'Montserrat', Arial, Helvetica, sans-serif;
        text-decoration:none;
    }
	#stage{
		width:960px;
	}
</style>
<script>
	export default {
	  	name: 'brfooter',
		props: {
			// storeType: Number
		}
	}
</script>